import Http from './http'
import { buildFilterUrl } from '../util/url-util'

class MembrosService {
  constructor () {
    this.baseUrl = 'membros-biblioteca'
  }

  list() {
    return Http.get(`${this.baseUrl}/list?membro=1`)
  }

  getAll (filter, like) {
    let url = this.baseUrl

    if (filter) {
      url += `?${this.buildFilterUrl(filter, like)}`
    }

    return Http.get(url)
  }

  obraReferenciaEnable (id, value) {
    const req = {
      obra_referencia_enable: value
    }
    return Http.put(`${this.baseUrl}/${id}`, req)
  }
}

Object.assign(MembrosService.prototype, { buildFilterUrl })

export default new MembrosService()
